import React from 'react'
import "../styles/home.css"
import "../styles/attività.css"
import banco from "../images/banco.jpg"
import martello from "../images/martello.jpg"


const Attività = () => {
  return (
    <div className='attività'>
      <div className="nameAndPic">
        <div className='name'>
          <div>
            <div className='headline'>
              <h1 className="slide-in">Attività</h1>
            </div>
             <p>MSOI Torino propone ai propri soci eventi e attività di vario tipo durante
              l’anno accademico per conoscere e diffondere e mettere in pratica i temi
            e valori dell'internazionalismo, che molto spesso vengono solamente 
            studiati nelle aulee universitarie.
            </p>
          </div>
        </div>
        <img src={banco} alt="banco" className='bancoImage'/>
      </div>
      <div className='conferenze'>
        <div className='conferenzePar'>
          <h1 className='subHeadline'>Conferenze</h1>
          <p>Durante l’anno accademico M.S.O.I. Torino organizza conferenze su
            tematiche di portata internazionale, integrando di volta in volta 
            prospettive giuridiche, politologiche, economiche e altro ancora.</p>
          <p>Grazie al contributo della S.I.O.I. Piemonte – Valle d’Aosta e di 
            accademici, funzionari e diplomatici, ci impegniamo nell’offrire al 
            pubblico spunti di approfondimento e riflessione sulle principali 
            questioni concernenti la comunità internazionale, sia per attualità
            che per importanza storica, facendo perno sulla dinamicità e 
            reattività del contesto torinese.</p>
          <p>A conferenze di più ampio respiro, pensate in un’ottica prevalentemente
            divulgativa non solo per l’ambito accademico, ma anche per il grande 
            pubblico, affianchiamo momenti seminariali, studiati per stimolare il 
            dibattito e lo scambio di idee tra studenti.</p>
        </div>
      </div>
      <div className='simulation'>
        <h1 className='subHeadline'>Simulation game storico</h1>
        <p>
        Si tratta della simulazione di una seduta storica del Consiglio di Sicurezza
         delle Nazioni Unite durante la quale i partecipanti diventano diplomatici per
          un giorno, rappresentano la posizione dello Stato loro assegnato rispetto ad 
          una questione di rilevanza internazionale di fronte agli altri delegati e 
          cercano di giungere, attraverso il dibattito e la mediazione diplomatica, 
          all’approvazione di una Risoluzione concernente il tema storico della seduta.
        </p>
        <p>• Obiettivo</p>
        <p className='subParag'>Lo scopo della simulazione è di raggiungere, 
        dopo faticose ma stimolanti ed  entusiasmanti negoziazioni, un progetto
         di Risoluzione condivisa, discussa e votata secondo le regole procedurali
          delle Nazioni Unite. </p>
        <p>• Novità</p>
        <p className='subParag'>Di recente abbiamo introdotto un nuovo tipo di simulazione
        storica, durante la quale viene riprodotta una seduta del Consiglio di Sicurezza
        delle Nazioni Unite riguardante vicende storiche realmente avvenute nel passato
        e concernente importanti avvenimenti della storia delle relazioni internazionali.</p>
      </div>
      <div className='model'>
        <div className='eumodel'>
          <div className='modelInfos'>
            <h1 className='subHeadline'>EU Model</h1>
            <p>Il più famoso evento di simulazione che MSOI Torino propone è l’EU Model Torino.
              La simulazione, giunta alla sua ottava edizione, ha luogo durante il mese di 
              marzo e si svolge interamente in lingua inglese. L’evento ha una durata di tre
              giorni di dibattito durante i quali gli studenti partecipanti rappresenteranno
              uno Stato del Consiglio dell’Unione Europea, un Parlamentare Europeo oppure una testata 
              Giornalistica contemporanea.
            </p>
            <p><a href="http://www.eumodeltorino.org/" className='modelink' 
            target="_blank" rel="noreferrer">Visita il sito</a></p>
          </div>
          <div className='martelloSpace'><img src={martello} alt="" className='martelloImg'/></div>
        </div>
        <p>Come funziona: </p>
        <p className='subParag'>Il dibattito durerà tre giorni nei quali, gli studenti
         partecipanti rappresenteranno uno Stato del Consiglio, un Parlamentare Europeo 
         oppure una testata giornalistica contemporanea.</p>
         
        <p className='subParag'>• Un Membro del Parlamento</p>
        <p className='subSubParag'>Il Parlamento Europeo è l’organo dell’UE che rappresenta
           direttamente la cittadinanza. Diviso attualmente in sette partiti, tu avrai la
            possibilità di simulare uno dei suoi membri. La maggior parte dei lavori più 
            dettagliati vengono svolti da delle apposite commissioni, le quali preparano 
            resoconti che verranno in seguito votati nelle sessioni plenarie.</p>

        <p className='subParag'>• Un Membro del Consiglio</p>
        <p className='subSubParag'>Il Consiglio dell'Unione Europea è costituito da ministri 
          o altri rappresentanti scelti dagli stati membri. Nel consiglio, i ministri 
          provenienti da ogni stato, si incontrano per negoziare e adottare nuovi regolamenti
           che andranno a coordinare le politiche degli stati membri e a sviluppare le 
           politiche di sicurezza ed estere. Infine, vengono ratificati trattati internazionali.
        </p>
        
        <p className='subParag'>• Un Membro dei Press Corps</p>
        <p className='subSubParag' id="endingPar">I componenti di una testata giornalistica avranno la 
          responsabilità di agire e scrivere seguendo le ideologie di un determinato 
          giornale. I resoconti e gli articoli pubblicati, assieme alle interviste, saranno
           in grado di influenzare sia le azioni del Parlamento che quelle del Consiglio.
          </p>
      </div>
    </div>
  )
}

export default Attività